<script setup lang="ts">
import {
  DrawerContent,
  DrawerOverlay,
  DrawerPortal,
  DrawerRoot,
} from 'vaul-vue';
import BaseTitle from '@/js/account/components/base/BaseTitle.vue';
import { classNames } from '@/js/lib/bem';

withDefaults(
  defineProps<{
    title?: string
  }>(),
  {
    title: undefined,
  },
);

const open = defineModel<boolean>('open', { default: false });

const cn = classNames('base-bottom-sheet');
</script>

<template>
  <DrawerRoot v-model:open="open" :should-scale-background="false">
    <slot name="trigger" />

    <DrawerPortal>
      <DrawerOverlay :class="cn('overlay')" />
      <DrawerContent :class="cn('content')">
        <div :class="cn('handle')" aria-hidden="true" />

        <BaseTitle v-if="title" size="sm" :class="cn('title')">
          {{ title }}
        </BaseTitle>

        <div :class="cn('body')">
          <slot />
        </div>
      </DrawerContent>
    </DrawerPortal>
  </DrawerRoot>
</template>

<style lang="scss">
.base-bottom-sheet {
  &__overlay {
    position: fixed;
    inset: 0;
    z-index: 100;
    background-color: rgb(0 0 0 / 40%);
  }

  &__content {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 101;
    display: flex;
    flex-direction: column;
    max-height: 85vh;
    padding: 8px 16px calc(24px + env(safe-area-inset-bottom, 0));
    background-color: var(--color-white);
    border-radius: 16px 16px 0 0;
    outline: none;
  }

  &__handle {
    flex-shrink: 0;
    width: 40px;
    height: 4px;
    margin: 0 auto 16px;
    border-radius: 2px;
    background-color: var(--base-field-border-color, #e0e0e0);
  }

  &__title {
    margin: 0 0 16px;
    padding: 0 8px 16px;
    color: var(--color-text-primary);
    font-family: var(--font-family-serif);
    line-height: 1.2;
    border-bottom: 1px solid var(--base-field-border-color, #e0e0e0);
  }

  &__body {
    overflow-y: auto;
  }
}
</style>
